module.exports = __webpack_public_path__ + "static/media/ic-mail.a096cf3b.svg";